import { Button, Form, Input, InputNumber, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { GET } from '../../../utils/requestActionConstants';
import { API_ROUTE } from '../../../utils/commonConstants';
import { fetcher } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { addCategory, updateCategory } from '../../../store/slices/categorySlice';

const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 6,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 14,
      },
    },
  };

function AddCategory({ onSwitchTab, tabProps = {} }) {
    const category = useSelector(state => state.categorySlice.category);
    const loading = useSelector(state => state.categorySlice.loading);
    const [form] = Form.useForm();
    const [slug, setSlug] = useState("");
    const dispatch = useDispatch();

    useEffect(() => {
      loadValues();
    }, [category]);

    const loadValues = () => {
      if (category.id) {
        form.setFieldsValue(category);
      } else {
        form.resetFields();
      }
    }

    const saveCategory = (data) => {
      if (category.id) {
        dispatch(updateCategory({categoryId: category.id, categoryData: data}));
      } else {
        dispatch(addCategory({categoryData: data}));
      }
    }

    const setFormSlugValue = (value) => {
      let slugValue = value.split(' ').join('-').toLowerCase();
      setSlug(slugValue);
      form.setFieldValue('slug', slugValue);
    }

    return (
        <div>
          <div className='text-center py-2 mb-10 mt-5 font-bold p-5 rounded-lg mx-auto w-fit text-xl '>{category.id ? "Update category" : "Add New category"}</div>
            <Form
                form={form}
                layout='verticle'
                {...formItemLayout}
                style={{
                    maxWidth: 600,
                    margin: 'auto'
                }}
                onFinish={saveCategory}
            >
                <Form.Item
                    label="Category Name"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: 'Enter category name here',
                        },
                    ]}
                >
                    <Input placeholder='Name of the category' onChange={(event) => { setFormSlugValue(event.target.value) }} />
                </Form.Item>
                <Form.Item
                    label="Category Slug"
                    name="slug"
                    rules={[
                        {
                            required: true,
                            message: 'Enter category slug here',
                        },
                    ]}
                >
                    <Input placeholder='Slug of the category' />
                </Form.Item>
                <Form.Item wrapperCol={{sm: {offset: 6, span: 14}, xs: {offset: 0, span: 14}}}>
                  <div className='flex justify-between'>
                      <div>{ category.id ? <Button onClick={loadValues}>Revert Changes</Button> : <></>}</div>
                      <div className='flex'>
                        <Button danger type='text' htmlType='reset'>Clear</Button>
                        <Button type='primary' loading={loading.saving} htmlType='submit'>{category.id ? "Update" : "Save"}</Button>
                      </div>
                  </div>
                </Form.Item>
            </Form>
        </div>
    )
}

export default AddCategory